import { PlannedDemandPageThemeSizeConfig } from './types';

const medium: PlannedDemandPageThemeSizeConfig = {
  plannedDemandPage: {},
};

export default medium;
